module.exports = __webpack_public_path__ + "static/media/desk-front.665370dc.png";